export { default as WorkshopSchedule } from './WorkshopSchedule';
